import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { ScrollSmoother } from 'gsap/ScrollSmoother';
import addVisibilityObserver from '@/js/components/useVisibilityObserver';
import BaseComponent from './baseComponent';

gsap.registerPlugin(ScrollTrigger);

export default class ContentFullbackground extends BaseComponent {
  /**
   * Public constructor
   *
   * @param options
   */
  constructor(options) {
    super(options);
    this.el = document.querySelector('[data-content-fullbackground]');
    this.breakPointL = 992;
    this.debug = false;
    this.isVisible = false;
    this.wasVisible = false;

    if (this.el) {
      this.eyebrow = this.el.querySelector('.title > .eyebrow');
      this.title = this.el.querySelector('.title > .title');
      this.lead = this.el.querySelector('.lead');
      this.background = this.el.querySelector('.image.-background');
      this.foreground1 = this.el.querySelector('.image.-foreground1');
    }
  }

  init() {
    if (!this.el) {
      return;
    }

    addVisibilityObserver(this.el, {
      onFirstEnter: () => {
        console.log('ContentFullBackground initialised');
        this.animation();
      },
    }, {
      // rootMargin: '-500px',
      threshold: 0,
    });
  }

  animation() {
    const mm = gsap.matchMedia();

    mm.add(
      {
        isL: `(min-width: ${this.breakPointL}px)`,
      },
      () => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: this.el,
            pin: true,
            start: 'top top', // when the top of the trigger hits the top of the viewport
            end: () => '+=800', // end after scrolling 800px beyond the start
            scrub: 0.1, // smooth scrubbing, takes 0.1 second to "catch up" to the scrollbar
            // snap: {
            //   snapTo: 'labels', // snap to the closest label in the timeline
            //   duration: { min: 0.2, max: 3 }, // the snap animation at least 0.2 seconds !> 3
            //   delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snap
            //   ease: 'power1.inOut', // the ease of the snap animation ("power3" by default)
            // },
            markers: this.debug,
          },
        });

        tl.addLabel('start')
          // .from(this.background, 0.5, { y: 100 }, 0)
          .from(this.foreground1, 1, { y: 100 }, 0)
          .addLabel('title')
          .from(this.eyebrow, 0.4, { scale: 1.5, marginTop: 36 }, 0.5)
          .from(this.title, 0.4, { scale: 2.25 }, 0.5)
          .addLabel('lead')
          .from(this.lead, 0.25, { autoAlpha: 0 })
          .addLabel('end');
      },
    );

    window.addEventListener('resize', () => ScrollTrigger.refresh());
    window.addEventListener('load', () => ScrollTrigger.refresh());

    return this;
  }
}
